import { useContext } from "react";

import { DispatchContext, type DispatchProcoreStampMenuItems, type State, StateContext } from "./reducer";

export function useProcoreStampMenuItems(): State {
    const context = useContext(StateContext);

    if (context === undefined) {
        throw new Error("useProcoreStampMenuItems must be used within a ProcoreStampProvider");
    }

    return context;
}

export function useDispatchProcoreStampMenuItems(): DispatchProcoreStampMenuItems {
    const context = useContext(DispatchContext);

    if (context === undefined) {
        throw new Error("useDispatchProcoreStampMenuItems must be used within a ProcoreStampProvider");
    }

    return context;
}
